import { DFT_BRAND } from '../../styles/brandPalette';

/**
 * Help / Learning Center chrome — aligned with Collections workspace.
 * Typography (sizes, spacing, H1–H3, paragraphs, lists, code, note) matches
 * the in-app reader layout at the shared Win/Mac page zoom.
 */
export const HELP_DOC_THEME = {
  /** Primary accent (headings underline, nav selection, key actions) */
  accent: '#1d4ed8',
  accentDark: '#1e40af',
  accentSoft: 'rgba(29, 78, 216, 0.12)',
  /** @deprecated Use accent — kept for gradual migration */
  orange: '#1d4ed8',
  orangeDark: '#1e40af',
  orangeSoft: 'rgba(29, 78, 216, 0.12)',
  pageBg: DFT_BRAND.bg,
  sidebarBg: DFT_BRAND.paper,
  contentBg: DFT_BRAND.paper,
  border: DFT_BRAND.line,
  borderLight: DFT_BRAND.line,
  text: DFT_BRAND.text,
  textMuted: DFT_BRAND.muted,
  navActiveBg: 'rgba(29, 78, 216, 0.1)',
  navActiveBorder: '#1d4ed8',
  link: DFT_BRAND.link,
  fontBody: 'Arial, Helvetica, sans-serif',
  fontMono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace',
  tableHeaderBg: DFT_BRAND.tint,
} as const;

/** Mirrors documentation.html rules for prose (h1–h3, p, ul, code, .note). */
export const HELP_DOC_TYPOGRAPHY = {
  lineHeight: 1.6,
  contentMaxPx: 1400,
  articlePadding: { xs: '12px 12px', sm: '14px 14px', md: '16px 16px' },
  h1: {
    fontSize: '1.375rem',
    fontWeight: 700,
    marginBottom: '10px',
    lineHeight: 1.25,
    color: HELP_DOC_THEME.text,
  },
  h2: {
    fontSize: '1.125rem',
    fontWeight: 700,
    marginTop: '24px',
    marginBottom: '8px',
    paddingBottom: '6px',
    borderBottom: `2px solid ${HELP_DOC_THEME.accent}`,
    lineHeight: 1.3,
    color: HELP_DOC_THEME.text,
  },
  /** First major heading inside article body — tighter top than following h2s */
  h2First: {
    marginTop: '16px',
  },
  h3: {
    fontSize: '1rem',
    fontWeight: 700,
    marginTop: '18px',
    marginBottom: '8px',
    lineHeight: 1.35,
    color: HELP_DOC_THEME.text,
  },
  paragraph: {
    marginBottom: '12px',
    lineHeight: 1.5,
    fontSize: '0.9375rem',
    color: HELP_DOC_THEME.text,
  },
  list: {
    marginLeft: '20px',
    marginBottom: '15px',
    paddingLeft: '0',
    listStylePosition: 'outside' as const,
  },
  listItem: {
    marginBottom: '6px',
    lineHeight: 1.6,
    color: HELP_DOC_THEME.text,
  },
  code: {
    backgroundColor: '#f0f0f0',
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '0.9em',
    fontFamily: HELP_DOC_THEME.fontMono,
  },
  note: {
    background: '#f5f9ff',
    borderLeft: `4px solid ${HELP_DOC_THEME.accent}`,
    padding: '12px 16px',
    margin: '16px 0',
  },
  hr: {
    margin: '30px 0',
    border: 'none',
    borderTop: `1px solid ${HELP_DOC_THEME.border}`,
  },
} as const;
